import React, { FC, useCallback } from 'react';
import {
  useGetUserNotifications,
  useReadUserNotification,
  useReadUserNotifications,
} from 'memberPortalApi/userNotification.api';
import UserNotificationsPopover from 'components/Header/components/UserNotificationsPopover';
import UserNotificationsContextProvider from 'components/Header/components/UserNotificationsContextProvider';

interface IMemberPortalUserNotificationsContentProvider {
  menuAnchorEl: HTMLElement | null;
  onClose: () => void;
}

const MemberPortalUserNotificationsContentProvider: FC<IMemberPortalUserNotificationsContentProvider> = ({
  menuAnchorEl,
  onClose,
}) => {
  const [readUN, { isLoading: readUNLoading }] = useReadUserNotification();
  const [readUNs, { isLoading: readUNsLoading }] = useReadUserNotifications();
  const { data: unPayload, isLoading } = useGetUserNotifications();
  const userNotifications = unPayload?.data || [];

  const readUserNotification = useCallback(
    (notificationId: string, read: boolean): Promise<void> => {
      return readUN({ uuid: notificationId, read })
        .unwrap()
        .catch(() => {});
    },
    [readUN],
  );

  const readUserNotifications = useCallback((): Promise<void> => {
    return readUNs()
      .unwrap()
      .catch(() => {});
  }, [readUNs]);

  return (
    <UserNotificationsContextProvider
      readUserNotification={readUserNotification}
      readUserNotifications={readUserNotifications}
      readUserNotificationLoading={readUNLoading}
      readUserNotificationsLoading={readUNsLoading}
    >
      <UserNotificationsPopover
        userNotifications={userNotifications}
        menuAnchorEl={menuAnchorEl}
        onClose={onClose}
        loading={isLoading}
      />
    </UserNotificationsContextProvider>
  );
};

export default MemberPortalUserNotificationsContentProvider;
